<template>
  <el-dialog :visible.sync="showModal" title="选择题目" append-to-body>
    <el-form :model="searchForm" label-width="100px" ref="form" inline size="small">
      <el-form-item label="题目" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入关键字" />
      </el-form-item>
      <el-form-item label="题型" prop="type">
        <el-select v-model="searchForm.type" style="width:100%">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in subjectType" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left: 50px">
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset('form')" style="margin-left: 8px">重置</el-button>
      </el-form-item>
    </el-form>
    <br />
    <el-table border v-loading="loading" :data="tableData" style="width: 100%" ref="table">
      <el-table-column label="选择" type="selection" prop="id" width="60" :selectable="checkSelectable" align="center" />
      <el-table-column label="题目" prop="title" align="center">
        <template slot-scope="{ row }">
          <div style="text-align: left;">{{row.title}}</div>
        </template>
      </el-table-column>
      <el-table-column label="题型" prop="title" width="150" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.type == 1 ? '' : row.type == 2 ? 'success' : row.type == 3 ? 'danger' : 'info'">{{row.type | typeFilter}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <div slot="footer">
      <el-button @click="showModal = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"
import { typeMoudel } from "../../mixins"
import { subjectType } from "../../dict"
import { examTopicPage, examPaperTopicAdds } from "../../api"

export default {
  mixins: [typeMoudel, tableMoudel],
  data () {
    return {
      subjectType,
      showModal: false,
      searchForm: {
        title: "",
        type: null,
      },
      examPaperId: null
    }
  },
  filters: {
    typeFilter (value) {
      return value ? subjectType.find(item => item.id == value).name : '--'
    }
  },
  methods: {
    checkSelectable: (row, index) => row.isInExamPaper == 1 ? false : true,
    init (examPaperId) {
      this.examPaperId = examPaperId
      this.showModal = true
      this.getData()
    },
    async getData () {
      const params = {
        ...this.pageInfo,
        ...this.searchForm
      }
      if (this.examPaperId) {
        params.examPaperId = this.examPaperId
      }
      const res = await examTopicPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    async submit () {
      const selectData = this.$refs.table.selection.map(item => item.id)
      if (selectData.length == 0) return this.$message.warning('请选择要关联的数据!')
      const params = selectData.map(item => {
        return {
          examTopicId: item,
          examPaperId: this.examPaperId
        }
      })
      const res = await examPaperTopicAdds(params)
      if (res.code !== 0) return this.$message.warning(res.message)
      this.$message.success('操作成功!')
      this.showModal = false
      this.$emit('update', true)
    }
  }
}
</script>

<style>
</style>
